import { assignmentIds, priorityKey } from './taskFilters.js'
import { dateValue } from './taskEditing.js'

export const bulkLimit = 50
const same = { skip: 'Al zo ingesteld' }

// Builds the Planner change for one task, or the reason it is skipped. Labels are per board, so they match by name.
export function bulkTaskChange(task, action) {
  if (!task['@odata.etag']) return { skip: 'Ververs het overzicht eerst' }
  switch (action.type) {
    case 'progress':
      return (task.percentComplete ?? 0) === action.value ? same : { changes: { percentComplete: action.value } }
    case 'priority':
      return priorityKey(task.priority ?? 5) === priorityKey(action.value) ? same : { changes: { priority: action.value } }
    case 'due':
      return dateValue(task.dueDateTime) === (action.value || '') ? same : { changes: { dueDateTime: action.value ? new Date(`${action.value}T00:00:00`).toISOString() : null } }
    case 'assign':
    case 'unassign': {
      const assigned = assignmentIds(task).includes(action.id)
      if (assigned === (action.type === 'assign')) return same
      return { changes: { assignments: { [action.id]: action.type === 'assign' ? { '@odata.type': 'microsoft.graph.plannerAssignment', orderHint: ' !' } : null } } }
    }
    case 'label': {
      const key = Object.entries(task.board.labels || {}).find(([, name]) => name?.trim() === action.name)?.[0]
      if (!key) return { skip: 'Dit bord heeft dit label niet' }
      return (task.appliedCategories?.[key] === true) === action.on ? same : { changes: { appliedCategories: { [key]: action.on } } }
    }
    default:
      throw new Error(`Unknown bulk action ${action.type}`)
  }
}
